<template>
    <dv-full-screen-container>
      <!--头部开始-->
      <el-row style="height: 10%">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 100%">
          <div class="header1 header">
            <div class=" header_time">
              <span class="year">{{ date }}</span>
              <span class="hour" style="margin-left: 10px">{{ time }}</span>
            </div>
            <div class="header_left_nav">
              <router-link to="/">
                <button class="butt ">首页</button>
              </router-link>
            </div>
            <div class="header_left_nav nav1" style="z-index: 100000000">
              <router-link to="/Arrondi2" >
                <button class="butt zq">文化</button>
              </router-link>
            </div>
            <div class=" header_title">
              <div class="header_img">
                <img src="../public/images/tixing.png" alt="">
                <div class="header_title_msg" style="left: 26%">
                  百万亩增产亿斤粮
                </div>
              </div>
            </div>
            <div class=" nav2 " style="z-index: 100000000">
              <router-link to="/Special2" >
                <button class="butt ">咱们店</button>
              </router-link>
            </div>
            <div class=" nav3">
              <router-link to="/SpecialCoun2" >
                <button class="butt ">农业</button>
              </router-link>
            </div>
            <div class=" nav5">
              <router-link to="/Information" >
                <button class="butt" >数据</button>
              </router-link>
            </div>
            <div class=" nav4">
              <button class="butt" v-on:click="login_out">退出</button>
            </div>
            <div class="clear-both"></div>
          </div>
        </el-col>
      </el-row>
      <!--头部完毕-->
      <el-row style="height: 45%">
        <el-col :span="8" style="height: 100%">
          <dv-border-box-1>
            <div class="title_msg">空气检测数据</div>
            <div style="height: 87%">
              <AirList msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
            </div>
          </dv-border-box-1>
        </el-col>
  
        <el-col :span="8" style="height: 100%">
          <div class="title_msg">示范基地</div>
          <div style="height: 90%">
            <img src="../assets/mapshowimage.png"  style="padding: 0 3%; width: 94%; height: 100%; " />
          </div>
        </el-col>
        <el-col :span="8" style="height: 100%">
            <dv-border-box-1>
              <div class="title_msg">地区排行</div>
              <div style="height: 87%; margin-top: 2%">
                <AreaRanking msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
              </div>
            </dv-border-box-1>
          </el-col>
      </el-row>
      <el-row style="height: 40%;margin-top: 1.7%">
        <el-col :span="8" style="height: 100%;">
          <dv-border-box-1>
            <div class="title_msg">智能灌溉监测数据</div>
            <div style="height: 83%; margin-top: 1%">

              <div style="height: 90%">
                <img src="../assets/guangai1.png"  style="padding: 0 3%; width: 90%; height: auto; " />
              </div>



              <!-- <ZGGalleries msg="专馆消费帮扶排行" style="padding: 0 3%; width: 94%; height: 100%"/> -->
            </div>
          </dv-border-box-1>
        </el-col>
        <el-col :span="8" style="height: 100%;">
          <dv-border-box-1>
            <div class="title_msg">土壤温湿度</div>
            <div style="height: 90%; margin-top: 1%">
              <temperature msg="专馆消费帮扶排行" style="padding: 0 3%; width: 94%; height: 90%"/>
            </div>
          </dv-border-box-1>
        </el-col>
        <el-col :span="8" style="height: 100%;">
          <dv-border-box-1>
            <div class="title_msg">土壤监测数据</div>
            <div style="height: 90%; margin-top: 1%">
             <div style="width: 100%; margin-top: 5%;height:  190px;">
                    <div style="width: 33%; float: left;"> 
                          <div style="padding: 0 3%; width: 40%; height: auto; float: left;">
                            <img src="../assets/sj2x.png" style="padding: 0 3%; width: 100%; height: auto; "/>
                          </div>
                            <div style="float: left; margin-top:8%;">
                              <div style="font-weight: bold; font-size: 22px; color: #06e7d7;">{{temperature}}℃</div>
                               <div style="margin-top: 1%;">温度</div>
                          </div>
                    </div>
                    <div style="width: 33%;float: left;"> 
                          <div style="padding: 0 3%; width: 40%; height: auto; float: left;">
                            <img src="../assets/sj2x.png" style="padding: 0 3%; width: 100%; height: auto; "/>
                          </div>
                            <div style="float: left; margin-top:8%;">
                              <div style="font-weight: bold; font-size: 22px; color: #06e7d7;">58%</div>
                               <div style="margin-top: 1%;">湿度</div>
                          </div>
                    </div>
                    <div style="width: 33%;float: left;"> 
                          <div style="padding: 0 3%; width: 40%; height: auto; float: left;">
                            <img src="../assets/sj2x.png" style="padding: 0 3%; width: 100%; height: auto; "/>
                          </div>
                            <div style="float: left; margin-top:8%;">
                              <div style="font-weight: bold; font-size: 22px; color: #06e7d7;">6.2</div>
                               <div style="margin-top: 1%;">ph值</div>
                          </div>
                    </div>
             </div>
             <div style="width: 100%; margin-top: 1%;height: 190px;" >
                    <div style="width: 33%; float: left;"> 
                          <div style="padding: 0 3%; width: 40%; height: auto; float: left;">
                            <img src="../assets/sj2x.png" style="padding: 0 3%; width: 100%; height: auto; "/>
                          </div>
                            <div style="float: left; margin-top:8%;">
                              <div style="font-weight: bold; font-size: 22px; color: #06e7d7;">986mg/kg</div>
                               <div style="margin-top: 1%;">氮</div>
                          </div>
                    </div>
                    <div style="width: 33%;float: left;"> 
                          <div style="padding: 0 3%; width: 40%; height: auto; float: left;">
                            <img src="../assets/sj2x.png" style="padding: 0 3%; width: 100%; height: auto; "/>
                          </div>
                            <div style="float: left; margin-top:8%;">
                              <div style="font-weight: bold; font-size: 22px; color: #06e7d7;">145mg/kg</div>
                               <div style="margin-top: 1%;">磷</div>
                          </div>
                    </div>
                    <div style="width: 33%;float: left;"> 
                          <div style="padding: 0 3%; width: 40%; height: auto; float: left;">
                            <img src="../assets/sj2x.png" style="padding: 0 3%; width: 100%; height: auto; "/>
                          </div>
                            <div style="float: left; margin-top:8%;">
                              <div style="font-weight: bold; font-size: 22px; color: #06e7d7;">228mg/kg</div>
                               <div style="margin-top: 1%;">钾</div>
                          </div>
                    </div>
             </div>

            </div>
          </dv-border-box-1>
        </el-col>
      </el-row>
    </dv-full-screen-container> 
  </template>
  
  <script>
  
  import Map3 from '@/views/map/Map3.vue'
  import AirList from '@/views/SpecialCoun2/AirList.vue'
  import ZGuConsumption from '@/views/zhuangui/ZGuConsumption.vue'
  import AreaRanking from '@/views/SpecialCoun2/AreaRanking.vue'
  import ZGGalleries from '@/views/zhuangui/ZGGalleries.vue'
  import temperature from '@/views/SpecialCoun2/temperature.vue'
  export default {
    name: "Special",
    data() {
      return {
        temperature:23,
        sales_data: [
          {
            name:"销售总额",
            value:'',
          },
          {
            name:"帮扶总额",
            value:'',
          },
          {
            name:"专柜个数",
            value:'',
          },
        ],
      }
    },
    components: {
      Map3,
      AreaRanking,
      ZGGalleries,
      ZGuConsumption,
      temperature,
      AirList
    },
    created(){
  
      let user_id = window.localStorage.getItem('user_id');
  
      // if (!user_id)
      // {
      //   this.$router.push({ path: '/Login' })
      //
      //   return false;
      // }
  
      const data = {
        'user_id': user_id
      };
      // this.$api.zgu_summary(data).then(res=>
      // {
      //   this.sales_data = res;
      // })
  
      var that = this;
      var timerID = setInterval(updateTime, 1000);
      updateTime();
  
      function updateTime() {
        var cd = new Date();
        that.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
        that.date = zeroPadding(cd.getFullYear(), 4) + '-' + zeroPadding(cd.getMonth()+1, 2) + '-' + zeroPadding(cd.getDate(), 2);
      };
  
      function zeroPadding(num, digit) {
        var zero = '';
        for(var i = 0; i < digit; i++) {
          zero += '0';
        }
        return (zero + num).slice(-digit);
      }

      //获取天气
      this.$http.get('https://api.seniverse.com/v3/weather/now.json?key=SCYrvkytJze9qyzOh&location=zhumadian&language=zh-Hans&unit=c')
        .then(response => {

          that.temperature=response.data.results[0].now.temperature;

         
        })
        .catch(error => {
          console.error('There was an error!', error);
        });

    

    },
    methods: {
      login_out:function(e){
        window.localStorage.clear();
        this.$notify({
          title: '成功',
          message: '退出登录',
          type: 'success'
        });
        this.$router.push({ path: '/Login' })
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  @import '../public/less/public/list.less';
  @import '../public/less/zhuanguan/zhuanguan.less';
  </style>